//simple toggle visibility for client listing module

const moduleClients = document.querySelector(".module--clients");

if (moduleClients) {
  const clientToggle = document.querySelector(".btn--client-toggle");

  function toggleClients() {
    document.querySelectorAll(".client-listing--secondary").forEach(item => {
      item.classList.toggle("clients-visible");
    });

    clientToggle.classList.toggle("showing-more");

    //toggle aria-expanded
    if (clientToggle.classList.contains("showing-more")) {
      clientToggle.innerHTML = "Show Less";
    } else {
      clientToggle.innerHTML = "Show More";
    }
  }

  clientToggle.addEventListener("click", toggleClients, false);
}
